import styled from 'styled-components';

export const CallMeBackStyles = styled.div`
  .close-btn {
    margin-top: 90px;
  }
`;
